"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMerkleDistributor = void 0;
const tslib_1 = require("tslib");
const bignumber_js_1 = require("bignumber.js");
const ImpactProvider_1 = require("./ImpactProvider");
const contracts_1 = require("./contracts");
const internalUseTransaction_1 = require("./internalUseTransaction");
const toNumber_1 = require("./toNumber");
const usePACTBalance_1 = require("./usePACTBalance");
const react_1 = tslib_1.__importStar(require("react"));
const useMerkleDistributor = (treeAccount) => {
    const { provider, address, signer, networkId } = react_1.default.useContext(ImpactProvider_1.ImpactProviderContext);
    const [hasClaim, setHasClaim] = (0, react_1.useState)(false);
    const [amountToClaim, setAmountToClaim] = (0, react_1.useState)(0);
    const executeTransaction = (0, internalUseTransaction_1.internalUseTransaction)();
    /**
     * Claims airgrab rewards.
     * @returns {ethers.ContractReceipt} tx response object
     */
    const claim = async () => {
        try {
            const { merkleDistributor } = (0, contracts_1.getContracts)(provider, networkId);
            if (!address || !signer) {
                return;
            }
            const tx = await merkleDistributor.populateTransaction.claim(treeAccount.index, address, treeAccount.amount, treeAccount.proof);
            const response = await executeTransaction(tx);
            (0, usePACTBalance_1.updatePACTBalance)(provider, networkId, address);
            return response;
        }
        catch (error) {
            console.log('Error claim: \n', error);
            return { status: false };
        }
    };
    (0, react_1.useEffect)(() => {
        const verifyClaim = async () => {
            const { merkleDistributor } = (0, contracts_1.getContracts)(provider, networkId);
            if (!address || !signer) {
                return;
            }
            if (treeAccount) {
                const _isClaimed = await merkleDistributor.isClaimed(treeAccount.index);
                setAmountToClaim((0, toNumber_1.toNumber)(new bignumber_js_1.BigNumber(treeAccount.amount, 16).toString()));
                setHasClaim(!_isClaimed);
            }
        };
        verifyClaim();
    }, [address]);
    return { amountToClaim, claim, hasClaim };
};
exports.useMerkleDistributor = useMerkleDistributor;
//# sourceMappingURL=useMerkleDistributor.js.map